import { Modal } from '@/components/design-system/Modal';

interface OrganizationModalsProps {
  showRemoveMemberModal: boolean;
  memberToRemove: { id: number; email: string } | null;
  onCloseRemoveMember: () => void;
  onConfirmRemoveMember: () => void;

  showCancelInvitationModal: boolean;
  invitationToCancel: { id: string; email: string } | null;
  onCloseCancelInvitation: () => void;
  onConfirmCancelInvitation: () => void;

  showLeaveOrgModal: boolean;
  onCloseLeaveOrg: () => void;
  onConfirmLeaveOrg: () => void;
}

export function OrganizationModals({
  showRemoveMemberModal,
  memberToRemove,
  onCloseRemoveMember,
  onConfirmRemoveMember,
  showCancelInvitationModal,
  invitationToCancel,
  onCloseCancelInvitation,
  onConfirmCancelInvitation,
  showLeaveOrgModal,
  onCloseLeaveOrg,
  onConfirmLeaveOrg,
}: OrganizationModalsProps) {
  return (
    <>
      <Modal
        open={showRemoveMemberModal}
        onClose={onCloseRemoveMember}
        title="Remover membro"
        size="small"
        primaryAction={{
          content: 'Remover',
          onAction: onConfirmRemoveMember
        }}
        secondaryAction={{
          content: 'Cancelar',
          onAction: onCloseRemoveMember
        }}
      >
        <p className="text-sm">
          Tem certeza que deseja remover <strong>{memberToRemove?.email}</strong> desta organização?
        </p>
      </Modal>

      <Modal
        open={showCancelInvitationModal}
        onClose={onCloseCancelInvitation}
        title="Cancelar convite"
        size="small"
        primaryAction={{
          content: 'Cancelar Convite',
          onAction: onConfirmCancelInvitation
        }}
        secondaryAction={{
          content: 'Voltar',
          onAction: onCloseCancelInvitation
        }}
      >
        <p className="text-sm">
          Tem certeza que deseja cancelar o convite para <strong>{invitationToCancel?.email}</strong>?
        </p>
      </Modal>

      <Modal
        open={showLeaveOrgModal}
        onClose={onCloseLeaveOrg}
        title="Sair da organização"
        size="small"
        destructiveAction={{
          content: 'Sair da Organização',
          onAction: onConfirmLeaveOrg
        }}
        secondaryAction={{
          content: 'Cancelar',
          onAction: onCloseLeaveOrg
        }}
      >
        <p className="text-sm">
          Tem certeza que deseja sair desta organização? Você perderá acesso a todos os recursos compartilhados.
        </p>
      </Modal>
    </>
  );
}
